export default "__VITE_ASSET__M$GuTWFD__"